import { useContext, useEffect, useState } from "react";
import MediaContext from "context/MediaContext";
import PropTypes from "prop-types";

export function useVideoDimensions() {
  const context = useContext(MediaContext);
  const [videoDimensions, setVideoDimensions] = useState({
    height: context.videoRef ? context.videoRef.videoHeight : 0,
    width: context.videoRef ? context.videoRef.videoWidth : 0,
  });

  const current = context.videoRef;

  useEffect(() => {
    if (!current) {
      return;
    }

    function handleLoadedData() {
      if (!current) {
        return;
      }

      setVideoDimensions({
        height: current.videoHeight,
        width: current.videoWidth,
      });
    }

    // In theory, we should be able to read the video's dimensions after we
    // receive the `loadedmetadata` event. I was seeing the dimensions still
    // not set in Safari _sometimes_ for this event. Instead of trying to get
    // the dimensions early, let's wait until the last possible moment.
    current.addEventListener("canplay", handleLoadedData);
    return () => {
      current.removeEventListener("canplay", handleLoadedData);
    };
  }, [current]);

  return videoDimensions;
}

export const UseVideoDimensions = ({ children }) =>
  children(useVideoDimensions());

UseVideoDimensions.propTypes = {
  children: PropTypes.func.isRequired,
};
